import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React from "react";
import Footer from "./Footer";
import Header from "./Header";
const useStyles = makeStyles((theme) => ({
    footer: {
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    },
}));
const Modal = ({ title, open, onClose, footer, neverMobile, className, hideCloseIcon, maxWidth, children, }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down("xs")) && !neverMobile;
    return (React.createElement(Dialog, { open: open, onClose: onClose, fullScreen: isMobileView, className: className, maxWidth: maxWidth },
        React.createElement(Header, { onClose: onClose, isMobileView: isMobileView, hideCloseIcon: hideCloseIcon }, title),
        React.createElement(DialogContent, null, children),
        React.createElement("div", { className: classes.footer }, footer || React.createElement(Footer, { onClose: onClose }))));
};
Modal.defaultProps = {
    neverMobile: false,
    footer: null,
    className: null,
};
export default Modal;
//# sourceMappingURL=index.js.map